import { TipoLog } from '../../../../shared/enum/tipo-log.enum';

export const ROTULOS_LOG: Record<TipoLog, string> = {
  [TipoLog.CRIACAO]: 'Atendimento criado',
  [TipoLog.TRANSFERENCIA]: 'Transferência',
  [TipoLog.FECHAMENTO]: 'Fechamento',
  [TipoLog.ENCERRAMENTO_ATENDIMENTO]: 'Atendimento encerrado',
  [TipoLog.INATIVACAO]: 'Atendimento inativado',
  [TipoLog.REINICIO_SESSAO]: 'Sessão reiniciada',
  [TipoLog.SESSAO_DERRUBADA]: 'Sessão derrubada',
  [TipoLog.EDICAO]: 'Sessão editada',
  [TipoLog.MUDANCA_CANAL]: 'Mudança de canal',
  [TipoLog.MUDANCA_ETAPA]: 'Mudança de etapa',
  [TipoLog.MUDANCA_FLUXO]: 'Mudança de fluxo',
  [TipoLog.ASSOCIACAO]: 'Associação',
  [TipoLog.DESASSOCIAR]: 'Desassociação',
  [TipoLog.REVOGAR]: 'Revogação',
  [TipoLog.PERMICAO]: 'Permissão',
  [TipoLog.EXCLUIR]: 'Exclusão'
};
